import api from '@api/Api';

export default {

    getDomain(id) {
        return api().get(`/domains/${id}`);
    },

    verifyDomain(id) {
        return api().put(`/domains/${id}/verify`);
    },

    deleteDomain(id) {
        return api().delete(`/domains/${id}`);
    },

}
